__webpack_require__.p = "/simulators/interview-questions/";